import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import client from '../../api';
import { picState } from '../../features/pic/picSlice';
import 'moment/locale/id';
import DatagridSiberat from '../../components/table/Datagrid';
import { Tooltip } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import Paging from '../../components/Paging';
import { Icon } from '@iconify/react';
import { formatExtNo } from '../../utils/formatSDL';

const DataOrder = ({ params }) => {
  moment.locale('id');
  const { user } = useSelector(state => state.auth);
  const pic = useSelector(picState);
  const [orderData, setOrderData] = useState({
    rowData: [],
    isLoading: false,
    totalPages: 0,
    totalDataAll: 0,
    totalDataPages: 0,
    total_orders_value: null
  });

  const [currentOrderPage, setCurrentOrderPage] = useState(1);
  const [refreshKey, setRefreshKey] = useState(0);

  const getData = async (pageNo = 1, pic = null, sizePage = 10) => {
    const response = await client.get(
      `/api/customers/dashboard/order?page=${pageNo}&size=${sizePage}&branch=${pic}`,
      {
        params,
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${user.data.token}`
        }
      }
    );
    return response.data;
  };

  const columns = [
    {
      field: 'id',
      headerName: 'No',
      width: 56,
      resizable: false,
      sortable: false,
      renderCell: item => (
        <p className='dashboard-cell__no'>
          {(currentOrderPage - 1) * 10 + item.row.key}.
        </p>
      )
    },
    {
      field: 'ext_no',
      headerName: 'Order',
      flex: 1.2,
      minWidth: 220,
      resizable: true,
      sortable: false,
      renderCell: cell => {
        const hasDoc = cell?.row?.po_file != null;
        const extNo = cell?.row?.ext_no;
        const shortExt = formatExtNo(extNo) || '-';
        return (
          <div className='dashboard-cell'>
            <Tooltip title={extNo || '-'} placement='top' arrow>
              <p className='dashboard-cell__title'>{shortExt}</p>
            </Tooltip>
            <p className='dashboard-cell__meta'>
              {moment(cell?.row?.date_of_loadingplan).format('DD MMM YYYY')}
            </p>
            <span
              className={`dashboard-doc-chip ${hasDoc ? 'is-ok' : 'is-warn'}`}>
              {hasDoc ? 'Dokumen tersedia' : 'Dokumen belum upload'}
            </span>
          </div>
        );
      }
    },
    {
      field: 'loads',
      headerName: 'Muatan',
      flex: 1.2,
      minWidth: 180,
      resizable: false,
      sortable: false,
      renderCell: cell => {
        const html = cell?.row?.loads || '-';
        const plain = String(html).replace(/<[^>]+>/g, '');
        const truncated = plain.length > 48;
        const content = (
          <div
            className='dashboard-cell__muatan'
            dangerouslySetInnerHTML={{
              __html: truncated ? `${plain.slice(0, 48)}...` : html
            }}
          />
        );
        return truncated ? (
          <Tooltip title={<div dangerouslySetInnerHTML={{ __html: html }} />}>
            {content}
          </Tooltip>
        ) : (
          content
        );
      }
    },
    {
      field: 'job_cost',
      headerName: 'Harga',
      width: 150,
      resizable: false,
      sortable: false,
      headerAlign: 'right',
      align: 'right',
      renderCell: cell => (
        <NumericFormat
          value={parseInt(cell?.row.costs ?? 0)}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'Rp '}
          renderText={value => (
            <p className='dashboard-cell__amount'>{value}</p>
          )}
        />
      )
    }
  ];

  let rows = [];
  orderData?.rowData?.map((item, key) =>
    rows.push({
      ...item,
      id: parseInt(item?.order_id),
      key: key + 1
    })
  );

  useEffect(() => {
    setOrderData(prevState => ({
      ...prevState,
      rowData: [],
      isLoading: true
    }));
    getData(currentOrderPage, pic)
      .then(info => {
        const {
          count,
          rowCount,
          rows,
          totalPages: total_pages,
          total_orders_value,
          currentPage
        } = info;
        setOrderData({
          isLoading: false,
          rowData: rows,
          total_orders_value: total_orders_value,
          totalPages: total_pages,
          totalDataPages: rowCount,
          totalDataAll: count
        });
        setCurrentOrderPage(currentPage);
      })
      .catch(() => toast.error('Internal Server Error'));
  }, [currentOrderPage, params, pic, refreshKey]);

  return (
    <div className='dashboard-activity'>
      <div className='dashboard-activity__head'>
        <div>
          <div className='dashboard-activity__title-row'>
            <h3 className='dashboard-activity__title'>Order On The Way</h3>
            <span className='dashboard-activity__count'>
              {orderData.totalDataAll || 0}
            </span>
          </div>
          <p className='dashboard-activity__subtitle'>
            Pesanan yang sedang dalam perjalanan
          </p>
          <Link to='/order' className='dashboard-activity__link'>
            Lihat semua
            <Icon icon='solar:arrow-right-linear' width={14} />
          </Link>
        </div>
        <div className='dashboard-activity__aside'>
          <div className='dashboard-activity__metric'>
            <p className='dashboard-activity__metric-label'>Total</p>
            <p className='dashboard-activity__metric-value'>
              {orderData?.total_orders_value ?? '-'}
            </p>
          </div>
          <button
            type='button'
            className={`dashboard-activity__refresh${
              orderData.isLoading ? ' is-spinning' : ''
            }`}
            disabled={orderData.isLoading}
            onClick={() => setRefreshKey(key => key + 1)}
            aria-label='Refresh order'>
            <Icon icon='solar:refresh-bold' width={18} />
          </button>
        </div>
      </div>

      <div className='dashboard-activity__body'>
        <DatagridSiberat
          columns={columns}
          loading={orderData.isLoading}
          rows={rows}
          columnBufferPx={5}
          getRowHeight={() => 'auto'}
          sortingMode={'server'}
          showPagination={true}
          overflowTable={true}
          heightTable={'650px'}
          filter_page={true}
          customPagination={
            <div className='dashboard-activity__footer'>
              <div
                className={`dashboard-activity__legend ${
                  orderData.isLoading ? 'is-hidden' : ''
                }`}>
                Showing{' '}
                {orderData.totalDataPages === 5
                  ? (currentOrderPage - 1) * orderData.totalDataPages + 1
                  : (currentOrderPage - 1) * 5 + 1}{' '}
                to{' '}
                {orderData.totalDataPages === 5
                  ? currentOrderPage * orderData.totalDataPages
                  : orderData.totalDataAll}{' '}
                of {orderData.totalDataAll} entries
              </div>
              <Paging
                count={orderData?.totalPages}
                page={currentOrderPage}
                onChange={(e, value) => {
                  setCurrentOrderPage(value);
                }}
              />
            </div>
          }
        />
      </div>
    </div>
  );
};

export default DataOrder;
